var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-card",
    {
      staticClass: "moulding-option",
      class: { selected: _vm.selected },
      attrs: { "no-body": "", "border-variant": _vm.selected ? "brand" : "" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "b-aspect",
        { attrs: { aspect: _vm.aspect } },
        [
          _c("b-card-img", {
            staticClass: "p-1",
            attrs: {
              src: _vm.length.chevron,
              "blank-src": "/images/mld-placeholder.png",
              "blank-height": _vm.imgHeight,
            },
          }),
        ],
        1
      ),
      _c("b-card-body", { staticClass: "p-2" }, [
        _c("span", { staticClass: "text-center" }, [
          _vm._v(
            _vm._s(_vm.length.colour.name) +
              " (" +
              _vm._s(_vm.length.itemCode) +
              ")"
          ),
        ]),
      ]),
      _c(
        "b-card-footer",
        { staticClass: "p-2" },
        [
          _c(
            "b-row",
            { staticClass: "text-center", attrs: { "align-h": "center" } },
            [
              _c("b-col", { attrs: { cols: "auto" } }, [
                _c("p", { staticClass: "mb-0" }, [
                  _c("small", [
                    _vm._v("Width"),
                    _c("br"),
                    _vm._v(_vm._s(_vm.length.width_mm) + "mm"),
                  ]),
                ]),
              ]),
              _c("b-col", { attrs: { cols: "auto" } }, [
                _c("p", { staticClass: "mb-0" }, [
                  _c("small", [
                    _vm._v("Depth"),
                    _c("br"),
                    _vm._v(_vm._s(_vm.length.depth_mm) + "mm"),
                  ]),
                ]),
              ]),
              _c("b-col", { attrs: { cols: "auto" } }, [
                _c("p", { staticClass: "mb-0" }, [
                  _c("small", [
                    _vm._v("R. Depth"),
                    _c("br"),
                    _vm._v(_vm._s(_vm.length.rebate_depth_mm) + "mm"),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.length.in_stock || (_vm.length.low_stock && !_vm.length.min_order)
        ? _c(
            "div",
            {
              staticClass: "stock-warning",
              class: { out: !_vm.length.in_stock, low: _vm.length.low_stock },
            },
            [_vm._v(_vm._s(_vm.length.in_stock ? `Low` : `Out of`) + " Stock")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }